import { GridBox, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { DamuseumDropdown } from "shared/components/DropdownSearchBar/DamuseumDropdown";
import { EduSecetWrapper, LegalsLabel } from "shared/modals/styles";
import { AppTester } from "supporting";

const EMPTY_VALUE = '';

const nominationList = {
    value_1: 'Молодежная номинация',
    value_2: 'Промышленный дизайн',
    value_3: 'Студийный дизайн',
    value_4: 'Циркулярный дизайн',
    value_5: 'Ювелирный дизайн',
    value_6: 'AI - технологии в дизайне',
    value_7: 'Зеленый граммофон'
}

const categoriesList: Record<string, string[]> = {
    value_1: ['Мебель', 'Свет', 'Предметы интерьера', 'Текстиль для дома', "Посуда"],
    value_2: ['Мебель','Свет', 'Предметы интерьера', 'Материалы отделки', 'Текстиль для дома','Посуда'],
    value_3: ["Мебель", "Свет", "Предметы интерьера", "Материалы отделки", "Текстиль для дома", "Посуда", "Интерьерные игрушки"],
    value_4: ['Промышленные продукты', 'Авторские предметы', 'Дизайн-инсталляции'],
    value_5: ['Ювелирные украшения', 'Циркулярный ювелирный дизайн', 'Дизайн-концепт'],
    value_6: ['Мебель', 'Свет', 'Предметы интерьера', 'Материалы отделки', 'Текстиль для дома', 'Посуда', 'Интерьерные игрушки', 'Ювелирное украшение' ],
    value_7: ['Зеленый граммофон']
}


export const DropdownBlock:FC<{ onSetAdditionalInfo: (nValue: string, cValue: string) => void}> = ({ onSetAdditionalInfo }) => {
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 );
    const isDamuseum = AppTester.isDaMuseum();
    const { t } = useTranslation();
    const [nominationValue, setNominationValue] = useState(EMPTY_VALUE);
    const [categoryValue, setCategoryValue] = useState(EMPTY_VALUE);

    const categoryList = useMemo(() => (categoriesList[nominationValue]), [nominationValue])

    const onNominationChange = useCallback((data: string) => {
        Object.entries(nominationList)?.forEach(([k,v]) => {
            if (data === v) {
                setNominationValue(k)
                onSetAdditionalInfo(v, 'nominationInfo')
            }
        } )
    }, [onSetAdditionalInfo ])

    
    const onCategoryChange = useCallback((data: string) => {
        setCategoryValue(categoryList.find((i) => i === data) || EMPTY_VALUE)
        onSetAdditionalInfo(categoryList.find((i) => i === data) || EMPTY_VALUE, 'categoryInfo')
    }, [categoryList, onSetAdditionalInfo])

    const nominationTitle = useMemo(() => {
        const title = Object.entries(nominationList)?.find(([k,v]) => {
            if (k === nominationValue) {
                return v;
            }
        })
        return title?.length ? title[1] : EMPTY_VALUE;
    } , [nominationValue])

    const nomination = useMemo(() => {
        return (
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start" }}>
                <LegalsLabel>{t('designer_edit.fields.nomination_info')}</LegalsLabel>
                <EduSecetWrapper>
                    <DamuseumDropdown 
                        editing={true}
                        onAddClick={(ev:any) => console.log('add', ev)}
                        onChooseClick={(ev: any) => console.log('choose',ev)}
                        currentValue={nominationTitle}
                        valueList={Object.values(nominationList)}
                        onValueChange={onNominationChange}
                    />
                </EduSecetWrapper>
            </GridBox>
        )
    }, [nominationTitle, isMobile, t, onNominationChange ])

    const category = useMemo(() => {
        if (nominationValue === '') return null;

        return (
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start" }}>
                <LegalsLabel>{t('designer_edit.fields.category_info')}</LegalsLabel>
                <EduSecetWrapper>
                    <DamuseumDropdown 
                        editing={true}
                        onAddClick={(ev:any) => console.log('add', ev)}
                        onChooseClick={(ev: any) => console.log('choose',ev)}
                        currentValue={categoryValue}
                        valueList={categoryList}
                        onValueChange={onCategoryChange}
                    />
                </EduSecetWrapper>
        </GridBox>
        )
    }, [categoryValue, categoryList, isMobile, t, nominationValue, onCategoryChange])

    if (!isDamuseum) {
        return null;
    }

    return (
        <>
            {nomination}
            {category}
        </>
    )
}import { GridBox, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { DamuseumDropdown } from "shared/components/DropdownSearchBar/DamuseumDropdown";
import { EduSecetWrapper, LegalsLabel } from "shared/modals/styles";
import { AppTester } from "supporting";

const EMPTY_VALUE = '';

const nominationList = {
    value_1: 'Молодежная номинация',
    value_2: 'Промышленный дизайн',
    value_3: 'Студийный дизайн',
    value_4: 'Циркулярный дизайн',
    value_5: 'Ювелирный дизайн',
    value_6: 'AI - технологии в дизайне',
    value_7: 'Зеленый граммофон'
}

const categoriesList: Record<string, string[]> = {
    value_1: ['Мебель', 'Свет', 'Предметы интерьера', 'Текстиль для дома', "Посуда"],
    value_2: ['Мебель','Свет', 'Предметы интерьера', 'Материалы отделки', 'Текстиль для дома','Посуда'],
    value_3: ["Мебель", "Свет", "Предметы интерьера", "Материалы отделки", "Текстиль для дома", "Посуда", "Интерьерные игрушки"],
    value_4: ['Промышленные продукты', 'Авторские предметы', 'Дизайн-инсталляции'],
    value_5: ['Ювелирные украшения', 'Циркулярный ювелирный дизайн', 'Дизайн-концепт'],
    value_6: ['Мебель', 'Свет', 'Предметы интерьера', 'Материалы отделки', 'Текстиль для дома', 'Посуда', 'Интерьерные игрушки', 'Ювелирное украшение' ],
    value_7: ['Зеленый граммофон']
}


export const DropdownBlock:FC<{ onSetAdditionalInfo: (nValue: string, cValue: string) => void}> = ({ onSetAdditionalInfo }) => {
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 );
    const isDamuseum = AppTester.isDaMuseum();
    const { t } = useTranslation();
    const [nominationValue, setNominationValue] = useState(EMPTY_VALUE);
    const [categoryValue, setCategoryValue] = useState(EMPTY_VALUE);

    const categoryList = useMemo(() => (categoriesList[nominationValue]), [nominationValue])

    const onNominationChange = useCallback((data: string) => {
        Object.entries(nominationList)?.forEach(([k,v]) => {
            if (data === v) {
                setNominationValue(k)
                onSetAdditionalInfo(v, 'nominationInfo')
            }
        } )
    }, [onSetAdditionalInfo ])

    
    const onCategoryChange = useCallback((data: string) => {
        setCategoryValue(categoryList.find((i) => i === data) || EMPTY_VALUE)
        onSetAdditionalInfo(categoryList.find((i) => i === data) || EMPTY_VALUE, 'categoryInfo')
    }, [categoryList, onSetAdditionalInfo])

    const nominationTitle = useMemo(() => {
        const title = Object.entries(nominationList)?.find(([k,v]) => {
            if (k === nominationValue) {
                return v;
            }
        })
        return title?.length ? title[1] : EMPTY_VALUE;
    } , [nominationValue])

    const nomination = useMemo(() => {
        return (
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start" }}>
                <LegalsLabel>{t('designer_edit.fields.nomination_info')}</LegalsLabel>
                <EduSecetWrapper>
                    <DamuseumDropdown 
                        editing={true}
                        onAddClick={(ev:any) => console.log('add', ev)}
                        onChooseClick={(ev: any) => console.log('choose',ev)}
                        currentValue={nominationTitle}
                        valueList={Object.values(nominationList)}
                        onValueChange={onNominationChange}
                    />
                </EduSecetWrapper>
            </GridBox>
        )
    }, [nominationTitle, isMobile, t, onNominationChange ])

    const category = useMemo(() => {
        if (nominationValue === '') return null;

        return (
            <GridBox cols={ isMobile ? '1fr': "1fr 4fr"} style={{ marginBottom: isMobile ? "16px" : '24px', placeItems: "center start" }}>
                <LegalsLabel>{t('designer_edit.fields.category_info')}</LegalsLabel>
                <EduSecetWrapper>
                    <DamuseumDropdown 
                        editing={true}
                        onAddClick={(ev:any) => console.log('add', ev)}
                        onChooseClick={(ev: any) => console.log('choose',ev)}
                        currentValue={categoryValue}
                        valueList={categoryList}
                        onValueChange={onCategoryChange}
                    />
                </EduSecetWrapper>
        </GridBox>
        )
    }, [categoryValue, categoryList, isMobile, t, nominationValue, onCategoryChange])

    if (!isDamuseum) {
        return null;
    }

    return (
        <>
            {nomination}
            {category}
        </>
    )
}